import {languages as BasicLanguages, global as BasicGlobal} from '@src/assets/data/constants'
import {features} from './features'
import {plans} from './plans'
import {CustomFieldTypes} from './CustomFieldTypes'
import {knowledgeBase} from './kb'
import {HelpBannersItems} from './HelpBannersItems'

const languages = {...BasicLanguages}
const global = {...BasicLanguages}

export {languages, global, features, plans, CustomFieldTypes, knowledgeBase, HelpBannersItems}
